import { OncologySubmissionApiResponse } from "../../../api/bigQuery/oncologySubmissionOrders";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { logError } from "../../../utils/customLogger";
import { AsteraOncologyExternalTableState } from "../hooks/useAsteraOncologyExternalTableData";
import { AsteraOncologyExternalFilterPayload } from "../hooks/useFilterPayload";
import { fetchAsteraOncologyExternalData } from "./fetchAsteraOncologyExternalData";

/**
 * makePostCallForInitialDataFetch - API Call for Initial Load
 *
 * Purpose: Fetches initial data when component mounts.
 * This is called once on component mount to load the first page of data.
 *
 * @param payload - Filter payload containing search params
 * @param setAsteraOncologyExternalState - State setter for API response
 * @param setTableData - State setter for table data
 */
export const makePostCallForInitialDataFetch = async (
  payload: AsteraOncologyExternalFilterPayload,
  setAsteraOncologyExternalState: React.Dispatch<
    React.SetStateAction<AsteraOncologyExternalTableState>
  >,
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>,
): Promise<void> => {
  try {
    setAsteraOncologyExternalState((prev) => ({
      ...prev,
      loading: true,
      error: null,
    }));

    const response: OncologySubmissionApiResponse =
      await fetchAsteraOncologyExternalData(payload);

    if (response.success) {
      setAsteraOncologyExternalState({
        data: response,
        loading: false,
        error: null,
        showInlineLoader: false,
      });
      setTableData(response.rows);
    } else {
      setAsteraOncologyExternalState((prev) => ({
        ...prev,
        loading: false,
        error: response.message || "Failed to fetch data",
      }));
    }
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    setAsteraOncologyExternalState((prev) => ({
      ...prev,
      loading: false,
      error: errorMessage,
    }));
    logError(error as Error, "Error in makePostCallForInitialDataFetch");
  }
};
